import { store } from "@betacrew/jars-flux";
import AppSwitchDataService from "../../../services/AppSwitchDataService";
import { setIsUserAuthenticated } from "../authentication/AuthenticationSlice";
import { resetSignInPage } from "../preloginscreens/signin/SignInSlice";
import { addNotifications } from "../toaster/ToasterPortalSlice";
import { componentKey, setLoadingState, setRedirectUrl } from "./AppSwitchSlice";
import { APP_SWITCH_RESPONSE_ACTIONS, APP_SWITCH_STATES } from "./constants";
import { all, put, takeLatest } from "redux-saga/effects";
import { TOASTER_VARIANT } from "../../components/toast/constants";

export const { loginWithSwitchExchangeToken, getSwitchExchangeToken } = {
    loginWithSwitchExchangeToken: (payload) => {
        return {
            type: "APP_SWITCH/LOGIN_WITH_SWITCH_EXCHANGE_TOKEN",
            payload: payload
        }
    },

    getSwitchExchangeToken: (payload) => {
        return {
            type: "APP_SWITCH/GET_SWITCH_EXCHANGE_TOKEN",
            payload: payload
        }
    },


}

function* loginWithSwitchExchangeTokenAsync(action) {
    try {
        yield put(setLoadingState({ state: APP_SWITCH_STATES.APP_SWITCH_LOADING }));
        const {data} = action.payload;
        const response = yield AppSwitchDataService.loginWithSwitchExchangeToken(data);

        if(response?.data){
            if(response?.data?.Status === 1){
                if(response.data.Data?.action === APP_SWITCH_RESPONSE_ACTIONS.SUCCESSFULLOGIN) {
                    yield put(setIsUserAuthenticated(true));
                }
            } else {
                switch(response.data.Data?.action) {
                    default:
                    case APP_SWITCH_RESPONSE_ACTIONS.LOGIN:
                        yield put(addNotifications({ heading: "Failed to sign in", message: response?.data?.Message }));
                        break;
                }
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to sign in", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: APP_SWITCH_STATES.APP_SWITCH_READY }));
    }
}

function* getSwitchExchangeTokenAsync(action) {
    try {
        yield put(setLoadingState({ state: APP_SWITCH_STATES.APP_SWITCH_LOADING }));
        const {source} = action.payload;
        const response = yield AppSwitchDataService.getSwitchExchangeToken(source);

        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setRedirectUrl(response.data.Data))
            } else {
                yield put(addNotifications({ 
                    heading: "Failed switch sessions", 
                    message: error?.response?.data?.Message 
                }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ 
            heading: "Failed switch sessions", 
            message: error?.response?.data?.Message 
        }));
        yield put(setLoadingState({ state: APP_SWITCH_STATES.APP_SWITCH_READY }));
    } finally {
    }
}

function* rootSaga() {
    yield all([
        takeLatest(loginWithSwitchExchangeToken().type, loginWithSwitchExchangeTokenAsync),
        takeLatest(getSwitchExchangeToken().type, getSwitchExchangeTokenAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);